// src/BracketIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var BracketIcon = ({ ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: "21",
    height: "21",
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M10.3336 7.83848C10.4855 7.4844 10.8961 7.32042 11.2502 7.47238C11.6042 7.62435 11.7682 8.03491 11.6163 8.38899L9.7558 12.724C9.60381 13.078 9.19323 13.242 8.83919 13.0901C8.48514 12.9382 8.3212 12.5276 8.47309 12.1735L10.3336 7.83848Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.2723 7.92751C13.5448 7.65505 13.9864 7.65505 14.2589 7.92751L16.1194 9.78797C16.3918 10.0604 16.3918 10.5021 16.1194 10.7745L14.2589 12.635C13.9864 12.9075 13.5448 12.9075 13.2723 12.635C12.9999 12.3625 12.9999 11.9209 13.2723 11.6484L14.6395 10.2812L13.2723 8.91406C12.9999 8.6416 12.9999 8.19997 13.2723 7.92751Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M5.83047 7.92751C6.10293 7.65505 6.54457 7.65505 6.81703 7.92751C7.08948 8.19997 7.08948 8.6416 6.81703 8.91406L5.44984 10.2812L6.81703 11.6484L6.86517 11.7011C7.08872 11.9752 7.07247 12.3795 6.81703 12.635C6.56158 12.8904 6.15719 12.9067 5.88316 12.6831L5.83047 12.635L3.97 10.7745C3.69755 10.5021 3.69755 10.0604 3.97 9.78797L5.83047 7.92751Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.0447 0.28125C15.5675 0.28125 20.0447 4.7584 20.0447 10.2812C20.0447 15.8041 15.5675 20.2812 10.0447 20.2812C4.52183 20.2812 0.0446777 15.8041 0.0446777 10.2812C0.0446777 4.7584 4.52183 0.28125 10.0447 0.28125ZM10.0447 1.6766C5.29246 1.6766 1.44003 5.52903 1.44003 10.2812C1.44003 15.0335 5.29246 18.8859 10.0447 18.8859C14.7969 18.8859 18.6493 15.0335 18.6493 10.2812C18.6493 5.52903 14.7969 1.6766 10.0447 1.6766Z",
          fill: "currentColor"
        }
      )
    ]
  }
);

export {
  BracketIcon
};
